export default {
    // START:: SET APP LOCALE
    setAppLocale(state, payload) {
        state.saudi_marche_language = payload;
    },
    // END:: SET APP LOCALE
};
